import { styled } from '@creditas-ui/system'
import type { MediaSizes } from '@creditas-ui/utilities'
import { getTypography, media } from '@creditas-ui/utilities'
import { Box } from '@creditas-ui/layout'
import type {
  TypographyProps,
  TypographyVariants,
  TypographyVariantProp,
  TypographyFontFamilies,
} from './types'

const setVariantByBreakpoint = (
  variant: TypographyVariants,
  breakpoint: string,
  theme: object,
  family: TypographyFontFamilies,
) => {
  if (breakpoint === '_') {
    return getTypography(
      variant,
      family,
    )({
      theme,
    })
  }

  return `
    ${media.up(breakpoint as keyof MediaSizes)} {
      ${getTypography(variant, family)({ theme })}
    }
  `
}

const getTypographyByBreakpoint = (
  breakpointVariants: TypographyVariantProp,
  theme: any,
  family: TypographyFontFamilies,
) => {
  const breakpointVariantsList = Object.entries(breakpointVariants)

  return breakpointVariantsList.map(value => {
    const [breakpoint, variant] = value || []
    return setVariantByBreakpoint(
      variant as TypographyVariants,
      breakpoint,
      theme,
      family,
    )
  })
}

const base = ({ theme, variant, family }: any) => {
  if (typeof variant === 'string') {
    return getTypography(variant as TypographyVariants, family)({ theme })
  }

  if (typeof variant === 'object') {
    return getTypographyByBreakpoint(variant, theme, family)
  }

  return ''
}

const TypographyElement = styled(Box.withComponent('p'))<TypographyProps>`
  ${base}
`

export { TypographyElement }
